import {colors} from "../../../colors";
import {makeStyles, Typography} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
    root: {
        height: "24px",
        borderRadius: "3px",
        width: "fit-content",
        whiteSpace: "nowrap"
    },
    blue: {
        backgroundColor: "#cbedf9"
    },
    gray: {
        backgroundColor: colors.grey.light
    },
    red: {
        backgroundColor: colors.error.light
    },
    blueText: {
        color: colors.tertiary.dark
    },
    redText: {
        color: colors.error.main
    },
    grayText: {
        color: colors.grey.dark
    }
}));

const StatusCardWithoutIcon = (props) => {
    const classes=useStyles();


    const whichColor = () => {
        if(props.color === "blue") {
            return {bg: classes.blue, txt: classes.blueText};
        }
        else if(props.color === "red") {
            return {bg: classes.red, txt: classes.redText};
        }
        else if(props.color === "gray") {
            return {bg: classes.gray, txt: classes.grayText};
        }
        else return null
    }
    return (
        props.text ?
        <div className={`${whichColor().bg} ${classes.root}`}>
            <Typography className={"mx-8 " + whichColor().txt} variant="overline">{props.text}</Typography>
        </div> : null
    )
}

export default StatusCardWithoutIcon;
